import { Button, Chip } from "@dash/form";
import { PageHeader } from "@dash/page";
import { useTheme } from "@emotion/react";
import { NavAccentThemeScope } from "@megarax/features";
import { MdArrowBack, MdHome } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

import { RecentDocsCard } from "./RecentDocsCard";
import { SignalsCard } from "./SignalsCard";

export const NotFoundPage: React.FC = () => {
  return (
    <NavAccentThemeScope>
      <NotFoundContent />
    </NavAccentThemeScope>
  );
};

const NotFoundContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const historyIndex: unknown = window.history.state?.idx;
  const canGoBack = typeof historyIndex === "number" && historyIndex > 0;

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "calc(100dvh - 10rem)",
        padding: "2rem 1rem",
      }}
    >
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.5rem",
          width: "100%",
          maxWidth: "30rem",
          minWidth: 0,
        }}
      >
        <div
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "4rem",
            height: "4rem",
            borderRadius: "50%",
            background: theme.colors.primaryLight,
            color: theme.colors.primary,
            fontFamily: theme.displayFontFamily,
            fontSize: "1.25rem",
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          404
        </div>

        <div
          css={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "0.5rem",
            width: "100%",
            minWidth: 0,
          }}
        >
          <PageHeader css={{ margin: 0, justifyContent: "center", h2: { fontSize: "1.375rem", textAlign: "center" } }}>
            Nie znaleziono strony
          </PageHeader>

          <span css={{ color: theme.colors.primary, opacity: 0.65, fontSize: "0.875rem", textAlign: "center" }}>
            Ten adres nie istnieje lub został przeniesiony.
          </span>

          <Chip
            variant="secondary"
            css={{
              fontSize: "0.75rem",
              padding: "0.25rem 0.5rem",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {location.pathname}
          </Chip>
        </div>

        <div css={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", justifyContent: "center", width: "100%" }}>
          {canGoBack && (
            <Button icon={<MdArrowBack />} onClick={() => navigate(-1)} css={{ whiteSpace: "normal" }}>
              Wróć na poprzednią stronę
            </Button>
          )}

          <Button
            variant="outline"
            icon={<MdHome />}
            onClick={() => navigate(getMegaraxPath.uri("megarax://home"))}
            css={{ whiteSpace: "normal" }}
          >
            Strona główna
          </Button>
        </div>

        <SignalsCard />

        <RecentDocsCard />
      </div>
    </div>
  );
};
